module.exports = __webpack_public_path__ + "img/like.b7457b0c.svg";